var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.989 10.01a6.006 6.006 0 0 1-3.64-1.222A6.064 6.064 0 0 1 20.945 4h-3.903v10.708l-.004 5.865a3.545 3.545 0 0 1-3.738 3.54 3.55 3.55 0 0 1-3.343-3.486 3.543 3.543 0 0 1 4.654-3.42v-3.979a7.65 7.65 0 0 0-1.125-.083A7.47 7.47 0 0 0 7.86 15.67a7.367 7.367 0 0 0-1.847 4.435 7.358 7.358 0 0 0 2.178 5.72A7.465 7.465 0 0 0 13.484 28c.38-.001.757-.03 1.126-.084a7.448 7.448 0 0 0 4.167-2.093 7.351 7.351 0 0 0 2.192-5.22l-.02-8.76A9.85 9.85 0 0 0 27 13.91v-3.902l-.011.001z",
    fill: "#4884E8",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTiktok);
export default __webpack_public_path__ + "static/media/social-tiktok.450b9f55.svg";
export { ForwardRef as ReactComponent };